import UnavailableResponse from '@/models/unavailableResponse';

export default class ProductAvailability {
  constructor(sku, isAvailable, unavailableDetails, zipCode) {
    this.sku = sku;
    this.isAvailable = isAvailable;
    this.unavailableCode = unavailableDetails.code ?? null;
    this.unavailableData = unavailableDetails.data ?? null;

    this.unavailableDefaultMessage = null;
    if (!this.isAvailable) {
      const unavailableResponse = new UnavailableResponse(this.unavailableCode, this.unavailableData, zipCode);
      this.unavailableDefaultMessage = unavailableResponse.message();
    }
  }
}